import resumeMsWordDoc from '../components/resume/gregsandell-resume-threePage.doc'
import resumePdf from '../components/resume/gregsandell-resume-threePage.pdf'
const S3_RESOURCES =
  'https://s3.us-west-1.amazonaws.com/gregsandell.com/resources'

export default class DocsManager {
  docs: { [index: string]: object | string } = {}

  constructor() {
    this.docs = {
      resumeMsWordDoc,
      resumePdf,
      '1995-01-01_roles_MP': `${S3_RESOURCES}/1995-01-01_roles_MP.pdf`,
      '1987-01-01_perception_MP': `${S3_RESOURCES}/1987-01-01_perception_MP.pdf`,
      '1995-05-01_absence_JASA': `${S3_RESOURCES}/1995-05-01_absence_JASA.pdf`,
      '1994-05-01_effect_JASA': `${S3_RESOURCES}/1994-05-01_effect_JASA.pdf`,
      '1984-04-06_ColumbiaVareseSymposium': `${S3_RESOURCES}/1984-04-06_ColumbiaVareseSymposium.pdf`,
      '1998-06-20_macrotimbre_ASA': `${S3_RESOURCES}/1998-06-20_macrotimbre_ASA.pdf`,
      '1996-12-04_recognition_ASA': `${S3_RESOURCES}/1996-12-04_recognition_ASA.pdf`,
      '1996-12-05_identifying_ASA': `${S3_RESOURCES}/1996-12-05_identifying_ASA.pdf`,
      '1994-06-09_effect_ASA': `${S3_RESOURCES}/1994-06-09_effect_ASA.pdf`,
      '1994-06-09_analysis_ASA': `${S3_RESOURCES}/1994-06-09_analysis_ASA.pdf`,
      '1989-11-29_effect_ASA': `${S3_RESOURCES}/1989-11-29_effect_ASA.pdf`,
      '1992-10-14_prototyping_ICMC': `${S3_RESOURCES}/1992-10-14_prototyping_ICMC.pdf`,
      '1991-10-01_library_ICMC': `${S3_RESOURCES}/1991-10-01_library_ICMC.pdf`,
      '1989-01-01_perception_ICMC': `${S3_RESOURCES}/1989-01-01_perception_ICMC.pdf`,
      '1997-07-31_perceptual_SMPC': `${S3_RESOURCES}/1997-07-31_perceptual_SMPC.pdf`,
      '1996-08-11_sharc_ICMPC': `${S3_RESOURCES}/1996-08-11_sharc_ICMPC.pdf`,
      '1995-06-22_grouping_SMPC': `${S3_RESOURCES}/1995-06-22_grouping_SMPC.pdf`,
      '1995-06-22_perceptual_SMPC': `${S3_RESOURCES}/1995-06-22_perceptual_SMPC.pdf`,
      '1992-02-22_factors_ICMPC': `${S3_RESOURCES}/1992-02-22_factors_ICMPC.pdf`,
      '1989-10-26_timbre_SMT': `${S3_RESOURCES}/1989-10-26_timbre_SMT.pdf`,
      '1990-09-01_soundColor_MTS': `${S3_RESOURCES}/1990-09-01_soundColor_MTS.pdf`,
      '1997-06-07_perceptual_ESCOM': `${S3_RESOURCES}/1997-06-07_perceptual_ESCOM.pdf`,
      '1996-06-01_auditory_MP': `${S3_RESOURCES}/1996-06-01_auditory_MP.pdf`,
      '1995-12-01_perceptual_JAES': `${S3_RESOURCES}/1995-12-01_perceptual_JAES.pdf`,
      //
      '01_diss_cover_TOC': `${S3_RESOURCES}/dissertation/01_diss_cover_TOC.pdf`,
      '02_diss_chapter_1': `${S3_RESOURCES}/dissertation/02_diss_chapter_1.pdf`,
      '03_diss_chapter_2': `${S3_RESOURCES}/dissertation/03_diss_chapter_2.pdf`,
      '04_diss_chapter_3': `${S3_RESOURCES}/dissertation/04_diss_chapter_3.pdf`,
      '05_diss_chapter_4': `${S3_RESOURCES}/dissertation/05_diss_chapter_4.pdf`,
      '06_diss_chapter_5': `${S3_RESOURCES}/dissertation/06_diss_chapter_5.pdf`,
      '07_diss_references': `${S3_RESOURCES}/dissertation/07_diss_references.pdf`,
      gregSandell1991DissertationEntire: `${S3_RESOURCES}/dissertation/gregSandell1991DissertationEntire.pdf`,
      '01_thesis_cover_TOC': `${S3_RESOURCES}/mastersThesis/01_cover_TOC.pdf`,
      '02_thesis_chapter_1': `${S3_RESOURCES}/mastersThesis/02_chapter_1.pdf`,
      '03_thesis_chapter_2': `${S3_RESOURCES}/mastersThesis/03_chapter_2.pdf`,
      '04_thesis_chapter_3': `${S3_RESOURCES}/mastersThesis/04_chapter_3.pdf`,
      '05_thesis_chapter_4': `${S3_RESOURCES}/mastersThesis/05_chapter_4.pdf`,
      '06_thesis_Bibliography': `${S3_RESOURCES}/mastersThesis/06_Bibliography.pdf`,
      '07_thesis_Appendix_01': `${S3_RESOURCES}/mastersThesis/07_Appendix_01.pdf`,
      '08_thesis_Appendix_02': `${S3_RESOURCES}/mastersThesis/08_Appendix_02.pdf`,
      '09_thesis_Appendix_03': `${S3_RESOURCES}/mastersThesis/09_Appendix_03.pdf`,
      Sandell_MastersThesis: `${S3_RESOURCES}/mastersThesis/Sandell_MastersThesis.pdf`,
    }
  }

  get(key: string): string {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    const thing: any = this.docs[key]
    return typeof thing === 'string' ? thing : URL.createObjectURL(thing)
  }
}
